import { render, staticRenderFns } from "./EditYoutubeVideo.vue?vue&type=template&id=65cd742d&scoped=true"
import script from "./EditYoutubeVideo.vue?vue&type=script&lang=js"
export * from "./EditYoutubeVideo.vue?vue&type=script&lang=js"
import style0 from "./EditYoutubeVideo.vue?vue&type=style&index=0&id=65cd742d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cd742d",
  null
  
)

export default component.exports